import { PageConfig } from '@helpers';
import React, { ComponentType, ReactElement, ReactNode } from 'react';

import { Layout } from './Layout/Layout';
import { ReadOnlyLayout } from './ReadOnlyLayout/ReadOnlyLayout';

type WithGetLayout<P> = ComponentType<P> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

export function withPageBase<P>(Component: ComponentType<P>) {
  const Wrapped: WithGetLayout<P & { config: PageConfig }> = props => <Component {...props} />;
  Wrapped.getLayout = (page: ReactElement) => <Layout>{page}</Layout>;
  return Wrapped;
}

export function withReadOnlyPageBase<P>(Component: ComponentType<P>) {
  const Wrapped: WithGetLayout<P & { config: PageConfig }> = props => <Component {...props} />;
  Wrapped.getLayout = (page: ReactElement) => <ReadOnlyLayout>{page}</ReadOnlyLayout>;
  return Wrapped;
}
